import { createStore } from 'vuex';
import * as modules from './modules';

export default createStore({ modules });
